'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utilSharedTitle = exports.sharedTitle = exports.isPublic = exports.getSharedUserCount = undefined;

var _userConstants = require('../../../../../common/users/userConstants');

var _permissionsService = require('../../../../utils/permissions/permissionsService');

// Constants
var getSharedUserCount = exports.getSharedUserCount = function getSharedUserCount(boardPermissions) {
    return (0, _permissionsService.getSharedUsers)(boardPermissions).length;
};

var isPublic = exports.isPublic = function isPublic(boardPermissions) {
    return Object.keys(boardPermissions).indexOf(_userConstants.PUBLIC_USER_ID) !== -1;
};

var buildSharingTitle = function buildSharingTitle(privateTitle) {
    return function (boardPermissions) {
        var compact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var sharedUserCount = getSharedUserCount(boardPermissions);

        if (sharedUserCount > 1) {
            if (compact) return 'Shared (' + sharedUserCount + ')';
            return 'Shared with ' + sharedUserCount + ' people';
        }

        if (isPublic(boardPermissions)) {
            return 'Shared';
        }

        return privateTitle;
    };
};

var sharedTitle = exports.sharedTitle = buildSharingTitle('Private');
var utilSharedTitle = exports.utilSharedTitle = buildSharingTitle('Share');


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/boardSharingHelpers.js
// module id = 476
// module chunks = 0